import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_RETAILER_CONTACT = `${URL_RETAILER_SCOPED}/retailer-contact`

export type DashRouteSet = DashRouteType<'retailer-contact'>

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'retailer-contact': URL_RETAILER_CONTACT,
}

export type DomainRouteName = keyof typeof routes
